import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api'; // Importa o serviço de API configurado
import AdminQuestoesPage from './AdminQuestoesPage';
import ProductManagement from './ProductManagement'; // Importar componente de gerenciamento de produtos
import CronogramaAccessManager from './Admin/CronogramaAccessManager'; // Importar componente de gerenciamento de acesso ao cronograma
import RegistrationRequestsPage from './RegistrationRequestsPage'; // Importar componente de gerenciamento de solicitações de registro
import TriAccessManager from './Admin/TriAccessManager'; // Importar componente de gerenciamento de acesso TRI
import {
  BarChart, Bar, LineChart, Line, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

// Estilos personalizados para a barra de rolagem
const scrollbarStyles = `
  .custom-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: #8b5cf6 #e9d5ff; /* Cor roxa do programa */
  }

  .custom-scrollbar::-webkit-scrollbar {
    width: 12px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f3e8ff; /* Fundo roxo claro */
    border-radius: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-track:hover {
    background: #e9d5ff;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: #8b5cf6; /* Cor roxa principal */
    border-radius: 6px;
    border: 2px solid #e9d5ff; /* Borda sutil */
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: #7c3aed; /* Tom mais escuro no hover */
  }
`;

// Componente de Menu Administrativo
const AdminMenu = ({ onNavigate, activePage }) => {
  const menuItems = [
    {
      id: 'users',
      name: 'Usuários',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>
        </svg>
      )
    },
    {
      id: 'groups',
      name: 'Grupos',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 1 1 -6 0 3 3 0 0 1 6 0zm6 3a2 2 0 1 1 -4 0 2 2 0 0 1 4 0zM7 10a2 2 0 1 1 -4 0 2 2 0 0 1 4 0z"></path>
        </svg>
      )
    },
    {
      id: 'requests',
      name: 'Solicitações',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
        </svg>
      )
    },
    {
      id: 'add-user',
      name: 'Adicionar Usuário',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
        </svg>
      )
    },
    {
      id: 'cronograma-access',
      name: 'Cronograma',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
        </svg>
      )
    },
    {
      id: 'sponsor',
      name: 'Patrocínio',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
        </svg>
      )
    },
    {
      id: 'section-access',
      name: 'Acesso a Seções',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
        </svg>
      )
    },
    {
      id: 'tri-access',
      name: 'Acesso TRI',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
        </svg>
      )
    },
  ];

  return (
    <div className="bg-white rounded-xl shadow-md p-4 mb-6">
      <nav className="flex flex-wrap gap-2">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            className={`flex items-center px-4 py-2 rounded-lg transition-colors ${
              activePage === item.id
                ? 'bg-violet-600 text-white'
                : 'text-gray-700 hover:bg-violet-100'
            }`}
          >
            {item.icon}
            <span className="ml-2 font-medium">{item.name}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

// Componente de Painel Administrativo
const AdminDashboard = ({ token, onVoltar }) => {
  const [stats, setStats] = useState({
    totalUsuarios: 0,
    usuariosComum: 0,
    usuariosPrata: 0,
    usuariosOuro: 0,
    mensagensUltimoDia: 0,
    mensagensUltimaSemana: 0,
    mensagensUltimoMes: 0
  });
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [dateRange, setDateRange] = useState('7'); // 7 dias por padrão
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');

  useEffect(() => {
    fetchAdminStats();
  }, [dateRange, customStartDate, customEndDate]);

  const fetchAdminStats = async () => {
    try {
      setLoading(true);
      setError('');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      // Buscar estatísticas gerais
      const statsResponse = await api.get('/api/admin/stats', config);
      setStats(statsResponse.data.stats);
      
    } catch (err) {
      console.error('Erro ao carregar estatísticas:', err);
      setError('Erro ao carregar estatísticas. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  // Preparar dados para gráficos (sem planos)
  const prepareUserPlanData = () => [];

  const prepareMessageData = () => [
    { name: '24h', value: stats.mensagensUltimoDia },
    { name: '7d', value: stats.mensagensUltimaSemana },
    { name: '30d', value: stats.mensagensUltimoMes }
  ];

  const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#0088fe'];

  // Função para testar o envio de email
  const handleTestEmail = async () => {
    try {
      // Enviar email de verificação para o seu email pessoal
      const response = await api.post('/api/users/register/request', {
        nome: 'Arthur Teste',
        email: 'arthurtmmcontatoprofissional@gmail.com',
        senha: 'SenhaSegura123!'  // Esta senha não será revelada no email
      });

      alert('Email de verificação enviado com sucesso! (Email enviado para: arthurtmmcontatoprofissional@gmail.com)\\n\\nVerifique sua caixa de entrada (ou spam) do Gmail. O email será enviado a partir da conta suporte.vestibula@gmail.com\\n\\nATENÇÃO: O email conterá APENAS um código de verificação, NENHUMA senha será revelada no conteúdo do email.');
    } catch (error) {
      console.error('Erro ao enviar email de teste:', error);
      alert('Erro ao enviar email de teste. O email pode já estar em uso ou o servidor de email não está configurado corretamente. Verifique o console para mais detalhes.');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Painel Administrativo</h1>
          </div>
          
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
            <p className="mt-4 text-gray-600">Carregando estatísticas...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Painel Administrativo</h1>
          </div>
          
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Erro! </strong>
            <span className="block sm:inline">{error}</span>
            <button 
              onClick={fetchAdminStats}
              className="mt-2 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition-colors"
            >
              Tentar Novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors mr-4"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Painel Administrativo</h1>
          </div>
          {/* Botão temporário para testar funcionalidade de email - REMOVER DEPOIS */}
          <button
            onClick={handleTestEmail}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded-lg transition-colors"
          >
            Testar Email
          </button>
        </div>

        {/* Estatísticas Gerais */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white p-6 rounded-xl shadow-md border border-violet-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Total de Usuários</p>
                <p className="text-3xl font-bold text-violet-600">{stats.totalUsuarios}</p>
              </div>
              <div className="bg-violet-100 p-3 rounded-full">
                <svg className="w-6 h-6 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 1 1 -6 0 3 3 0 0 1 6 0zm6 3a2 2 0 1 1 -4 0 2 2 0 0 1 4 0zM7 10a2 2 0 1 1 -4 0 2 2 0 0 1 4 0z"></path>
                </svg>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Plano Comum</p>
                <p className="text-3xl font-bold text-gray-600">{stats.usuariosComum}</p>
              </div>
              <div className="bg-gray-100 p-3 rounded-full">
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md border border-blue-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Plano Prata</p>
                <p className="text-3xl font-bold text-blue-600">{stats.usuariosPrata}</p>
              </div>
              <div className="bg-blue-100 p-3 rounded-full">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md border border-yellow-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Plano Ouro</p>
                <p className="text-3xl font-bold text-yellow-600">{stats.usuariosOuro}</p>
              </div>
              <div className="bg-yellow-100 p-3 rounded-full">
                <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Gráficos de Usuários e Mensagens */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {/* Total de Usuários */}
          <div className="bg-white p-6 rounded-xl shadow-md border border-violet-200">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Total de Usuários</h2>
            <div className="h-80 flex items-center justify-center">
              <div className="text-center">
                <div className="text-5xl font-bold text-violet-600 mb-2">{stats.totalUsuarios}</div>
                <div className="text-gray-600">Usuários Cadastrados</div>
              </div>
            </div>
          </div>

          {/* Gráfico de Mensagens */}
          <div className="bg-white p-6 rounded-xl shadow-md border border-green-200">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Mensagens</h2>
            <div className="h-80">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={prepareMessageData()}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip formatter={(value) => [value, 'Mensagens']} />
                  <Legend />
                  <Bar dataKey="value" name="Mensagens" fill="#82ca9d" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Componente de Gerenciamento de Usuários
const AdminUsers = ({ token, onVoltar, user, onUpdateUser }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [message, setMessage] = useState('');
  const [editingUser, setEditingUser] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [totalUsers, setTotalUsers] = useState(0); // Adicionando estado para contagem total
  const [editForm, setEditForm] = useState({
    nome: '',
    plano: 'comum'
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Buscar usuários reais do backend
      const response = await api.get('/api/admin/users', config);
      console.log('Dados recebidos do backend:', response.data);
      setUsers(response.data.users || []);
      // Definir a contagem total de usuários
      setTotalUsers(response.data.users ? response.data.users.length : 0);

    } catch (err) {
      console.error('Erro ao carregar usuários:', err);
      setMessage('Erro ao carregar usuários.');
    } finally {
      setLoading(false);
    }
  };

  const fetchUserDetails = async (userId) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      // Buscar detalhes do usuário
      const response = await api.get(`/api/admin/users/${userId}`, config);
      setSelectedUser(response.data.user);
      setShowUserDetails(true);
    } catch (err) {
      console.error('Erro ao carregar detalhes do usuário:', err);
      setMessage('Erro ao carregar detalhes do usuário.');
    }
  };

  const handleEditUser = (user) => {
    setEditingUser(user._id);
    setEditForm({
      nome: user.nome || '',
      plano: user.plano || 'comum'
    });
  };

  const handleSaveUser = async () => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Atualizar nome do usuário
      if (editForm.nome !== users.find(u => u._id === editingUser)?.nome) {
        await api.put(`/api/admin/users/${editingUser}/name`,
          { nome: editForm.nome },
          config
        );
      }

      // Atualizar plano do usuário
      if (editForm.plano !== users.find(u => u._id === editingUser)?.plano) {
        await api.put(`/api/admin/users/${editingUser}/plano`,
          { plano: editForm.plano },
          config
        );
      }

      setMessage('Usuário atualizado com sucesso!');
      setEditingUser(null);
      fetchUsers(); // Recarregar a lista e atualizar a contagem

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao atualizar usuário:', err);
      setMessage('Erro ao atualizar usuário.');
    }
  };

  const handleChangeCredits = async (userId, newCredits) => {
    // Função removida pois a funcionalidade de alterar créditos foi desativada
    setMessage('Funcionalidade de alteração de créditos desativada.');
    
    // Limpar mensagem após 3 segundos
    setTimeout(() => setMessage(''), 3000);
  };

  const handleResetPassword = async (userId, newPassword) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.post(`/api/admin/users/${userId}/reset-password`,
        { newPassword },
        config
      );

      setMessage('Senha do usuário resetada com sucesso!');
      setShowUserDetails(false);

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao resetar senha do usuário:', err);
      setMessage('Erro ao resetar senha do usuário.');
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.delete(`/api/admin/users/${userId}`, config);

      setMessage('Usuário excluído com sucesso!');
      setShowUserDetails(false);
      fetchUsers(); // Recarregar a lista e atualizar a contagem

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao excluir usuário:', err);
      setMessage('Erro ao excluir usuário.');
    }
  };

  const handlePromoteUser = async (userId) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.post(`/api/admin/users/${userId}/promote`, {}, config);

      setMessage('Usuário promovido a administrador com sucesso!');
      setShowUserDetails(false);
      fetchUsers(); // Recarregar a lista e atualizar a contagem

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao promover usuário:', err);
      setMessage('Erro ao promover usuário.');
    }
  };

  const handleDemoteUser = async (userId) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.post(`/api/admin/users/${userId}/demote-user`, {}, config);

      setMessage('Administrador rebaixado a usuário comum com sucesso!');
      setShowUserDetails(false);
      fetchUsers(); // Recarregar a lista e atualizar a contagem

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao rebaixar administrador:', err);
      setMessage('Erro ao rebaixar administrador.');
    }
  };

  // Funções para promoção/rebaixamento de planos

  // Funções para promoção/rebaixamento de administradores
  const handlePromoteToAdmin = async (userId) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.post(`/api/admin/users/${userId}/promote-admin`, {}, config);

      setMessage('Usuário promovido a administrador com sucesso!');
      setShowUserDetails(false);
      fetchUsers(); // Recarregar a lista e atualizar a contagem

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao promover usuário a administrador:', err);
      setMessage('Erro ao promover usuário a administrador.');
    }
  };

  const handleDemoteToUser = async (userId) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.post(`/api/admin/users/${userId}/demote-user`, {}, config);

      setMessage('Administrador rebaixado a usuário comum com sucesso!');
      setShowUserDetails(false);
      fetchUsers(); // Recarregar a lista e atualizar a contagem

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao rebaixar administrador:', err);
      setMessage('Erro ao rebaixar administrador.');
    }
  };


  const filteredUsers = users.filter(user => 
    user.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Usuários</h1>
          </div>
          
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
            <p className="mt-4 text-gray-600">Carregando usuários...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={onVoltar}
            className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
          <div className="text-right">
            <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Usuários</h1>
            <p className="text-gray-600 mt-1">Total de usuários: <span className="font-semibold text-violet-700">{totalUsers}</span></p>
          </div>
        </div>

        {message && (
          <div className={`mb-6 p-4 rounded-lg ${message.includes('Erro') ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
            {message}
          </div>
        )}

        {/* Barra de busca */}
        <div className="mb-6">
          <div className="relative">
            <input
              type="text"
              placeholder="Buscar usuários por nome ou email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
            />
            <svg className="w-5 h-5 text-gray-400 absolute left-3 top-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>

        {/* Lista de usuários */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Usuário
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Registro
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <tr key={user._id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10">
                            <div className="h-10 w-10 rounded-full bg-violet-100 flex items-center justify-center">
                              <span className="text-violet-800 font-semibold">
                                {user.nome ? user.nome.charAt(0).toUpperCase() : '?'}
                              </span>
                            </div>
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">{user.nome || 'Nome não disponível'}</div>
                            <div className="text-sm text-gray-500">{user.email || 'Email não disponível'}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {user.createdAt ? new Date(user.createdAt).toLocaleDateString('pt-BR') : 'N/A'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        {editingUser === user._id ? (
                          <div className="flex justify-end space-x-2">
                            <button
                              onClick={() => setEditingUser(null)}
                              className="text-gray-600 hover:text-gray-900"
                            >
                              Cancelar
                            </button>
                            <button
                              onClick={handleSaveUser}
                              className="text-violet-600 hover:text-violet-900 font-semibold"
                            >
                              Salvar
                            </button>
                          </div>
                        ) : (
                          <div className="flex justify-end space-x-2">
                            <button
                              onClick={() => fetchUserDetails(user._id)}
                              className="text-blue-600 hover:text-blue-900"
                              title="Ver detalhes"
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                              </svg>
                            </button>
                            <button
                              onClick={() => handleEditUser(user)}
                              className="text-violet-600 hover:text-violet-900"
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                              </svg>
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">
                      Nenhum usuário encontrado
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal de Detalhes do Usuário */}
      {showUserDetails && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 max-w-md w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Detalhes do Usuário</h3>
              <button 
                onClick={() => setShowUserDetails(false)}
                className="text-gray-500 hover:text-gray-800 text-2xl"
              >
                &times;
              </button>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="flex-shrink-0 h-12 w-12">
                  <div className="h-12 w-12 rounded-full bg-violet-100 flex items-center justify-center">
                    <span className="text-violet-800 font-semibold text-lg">
                      {selectedUser.nome ? selectedUser.nome.charAt(0).toUpperCase() : '?'}
                    </span>
                  </div>
                </div>
                <div className="ml-4">
                  <div className="text-lg font-medium text-gray-900">{selectedUser.nome || 'Nome não disponível'}</div>
                  <div className="text-sm text-gray-500">{selectedUser.email || 'Email não disponível'}</div>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-500">Plano</label>
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    selectedUser.plano === 'comum' ? 'bg-gray-100 text-gray-800' :
                    selectedUser.plano === 'prata' ? 'bg-blue-100 text-blue-800' :
                    'bg-yellow-100 text-yellow-800'
                  }`}>
                    {selectedUser.plano ? selectedUser.plano.charAt(0).toUpperCase() + selectedUser.plano.slice(1) : 'N/A'}
                  </span>
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-500">Registro</label>
                  <span className="text-sm font-medium text-gray-900">
                    {selectedUser.createdAt ? new Date(selectedUser.createdAt).toLocaleDateString('pt-BR') : 'N/A'}
                  </span>
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-500">Última Atividade</label>
                  <span className="text-sm font-medium text-gray-900">
                    {selectedUser.ultimaAtividade 
                      ? new Date(selectedUser.ultimaAtividade).toLocaleDateString('pt-BR')
                      : 'N/A'}
                  </span>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-500">Total de Questões</label>
                  <span className="text-sm font-medium text-gray-900">
                    {selectedUser.totalQuestoesRespondidas || 0}
                  </span>
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-500">Acertos</label>
                  <span className="text-sm font-medium text-gray-900">
                    {selectedUser.totalAcertos || 0}
                  </span>
                </div>
              </div>
              
              <div>
                <label className="block text-xs font-medium text-gray-500">Pontuação Total</label>
                <span className="text-sm font-medium text-gray-900">
                  {selectedUser.pontuacaoTotal || 0}
                </span>
              </div>


              <div className="pt-4 border-t border-gray-200">
                <button
                  onClick={() => {
                    const newPassword = prompt('Digite a nova senha para este usuário:');
                    if (newPassword && newPassword.length >= 6) {
                      handleResetPassword(selectedUser._id, newPassword);
                    } else if (newPassword) {
                      alert('A senha deve ter pelo menos 6 caracteres.');
                    }
                  }}
                  className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 mb-2"
                >
                  Resetar Senha
                </button>
                
                
                {/* Botões de promoção/rebaixamento de administrador */}
                {selectedUser && !selectedUser.isAdmin ? (
                  <button
                    onClick={() => selectedUser._id && handlePromoteToAdmin(selectedUser._id)}
                    className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 mb-2"
                  >
                    Promover a Administrador
                  </button>
                ) : (
                  <button
                    onClick={() => selectedUser._id && handleDemoteToUser(selectedUser._id)}
                    className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 mb-2"
                  >
                    Rebaixar a Usuário
                  </button>
                )}


                <button
                  onClick={() => {
                    if (selectedUser.nome && selectedUser._id && window.confirm(`Tem certeza que deseja excluir o usuário ${selectedUser.nome || 'usuário'}? Esta ação não pode ser desfeita.`)) {
                      handleDeleteUser(selectedUser._id);
                    }
                  }}
                  className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-800 hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Excluir Usuário
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AdminGroups = ({ token, onVoltar }) => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [silenceForm, setSilenceForm] = useState({
    grupoId: '',
    horas: 24
  });
  const [showSilenceModal, setShowSilenceModal] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState({}); // Track selected messages by groupId
  const [editingGroup, setEditingGroup] = useState(null); // Track which group is being edited
  const [editFormData, setEditFormData] = useState({ nome: '', descricao: '' }); // Track edit form data

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    try {
      setLoading(true);
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Buscar grupos
      const response = await api.get('/api/conecta/grupos', config);
      const grupos = response.data.grupos || [];

      // Buscar as mensagens para cada grupo individualmente para ter informações completas
      const gruposComMensagens = await Promise.all(grupos.map(async (grupo) => {
        try {
          const mensagensResponse = await api.get(`/api/conecta/grupos/${grupo._id}/messages`, config);
          return {
            ...grupo,
            mensagens: mensagensResponse.data.messages || []
          };
        } catch (msgErr) {
          console.error(`Erro ao carregar mensagens do grupo ${grupo._id}:`, msgErr);
          return {
            ...grupo,
            mensagens: [] // Retornar array vazio em caso de erro ao carregar mensagens
          };
        }
      }));

      setGroups(gruposComMensagens);

    } catch (err) {
      console.error('Erro ao carregar grupos:', err);
      setMessage('Erro ao carregar grupos.');
      // Dados de exemplo para demonstração
      setGroups([
        {
          _id: '1',
          nome: 'Grupo de Matemática',
          descricao: 'Grupo para discussão de matemática',
          categoria: 'Matemática',
          membros: [{_id: 'user1', nome: 'Usuário 1'}, {_id: 'user2', nome: 'Usuário 2'}],
          mensagens: [{_id: 'msg1', texto: 'Olá mundo!', autor: {_id: 'user1', nome: 'Usuário 1'}}]
        },
        {
          _id: '2',
          nome: 'Grupo de Português',
          descricao: 'Grupo para discussão de português',
          categoria: 'Português',
          membros: [{_id: 'user3', nome: 'Usuário 3'}],
          mensagens: []
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveMember = async (groupId, memberId) => {
    if (!window.confirm('Tem certeza que deseja remover este membro do grupo?')) {
      return;
    }
    
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      await api.delete(`/api/admin/grupos/${groupId}/membros/${memberId}`, config);
      
      setMessage('Membro removido com sucesso!');
      fetchGroups(); // Recarregar a lista
      
      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
      
    } catch (err) {
      console.error('Erro ao remover membro:', err);
      setMessage('Erro ao remover membro.');
    }
  };

  const handleDeleteMessage = async (groupId, messageId) => {
    if (!window.confirm('Tem certeza que deseja apagar esta mensagem?')) {
      return;
    }
    
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      await api.delete(`/api/admin/grupos/${groupId}/mensagens/${messageId}`, config);
      
      setMessage('Mensagem apagada com sucesso!');
      fetchGroups(); // Recarregar a lista
      
      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
      
    } catch (err) {
      console.error('Erro ao apagar mensagem:', err);
      setMessage('Erro ao apagar mensagem.');
    }
  };

  // Function to toggle message selection
  const toggleMessageSelection = (groupId, messageId) => {
    setSelectedMessages(prev => {
      const groupSelected = { ...prev[groupId] } || {};
      if (groupSelected[messageId]) {
        delete groupSelected[messageId];
      } else {
        groupSelected[messageId] = true;
      }

      return {
        ...prev,
        [groupId]: groupSelected
      };
    });
  };

  // Function to select all messages in a group
  const selectAllMessagesInGroup = (groupId, messages) => {
    setSelectedMessages(prev => {
      const groupSelected = {};
      messages.forEach(message => {
        groupSelected[message._id] = true;
      });

      return {
        ...prev,
        [groupId]: groupSelected
      };
    });
  };

  // Function to deselect all messages in a group
  const deselectAllMessagesInGroup = (groupId) => {
    setSelectedMessages(prev => ({
      ...prev,
      [groupId]: {}
    }));
  };

  // Function to delete selected messages in a group
  const deleteSelectedMessages = async (groupId) => {
    const selectedMsgIds = Object.keys(selectedMessages[groupId] || {});

    if (selectedMsgIds.length === 0) {
      setMessage('Nenhuma mensagem selecionada para exclusão.');
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    if (!window.confirm(`Tem certeza que deseja apagar ${selectedMsgIds.length} mensagem(ns)?`)) {
      return;
    }

    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Delete all selected messages
      for (const messageId of selectedMsgIds) {
        await api.delete(`/api/admin/grupos/${groupId}/mensagens/${messageId}`, config);
      }

      setMessage(`${selectedMsgIds.length} mensagem(ns) apagada(s) com sucesso!`);
      setSelectedMessages(prev => ({
        ...prev,
        [groupId]: {}
      }));
      fetchGroups(); // Recarregar a lista

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao apagar mensagens selecionadas:', err);
      setMessage('Erro ao apagar mensagens selecionadas.');
    }
  };

  // Function to start editing a group
  const startEditingGroup = (group) => {
    setEditingGroup(group._id);
    setEditFormData({
      nome: group.nome,
      descricao: group.descricao
    });
  };

  // Function to cancel editing
  const cancelEditingGroup = () => {
    setEditingGroup(null);
    setEditFormData({ nome: '', descricao: '' });
  };

  // Function to save group updates
  const saveGroupUpdates = async (groupId) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.put(`/api/conecta/grupos/${groupId}`, {
        nome: editFormData.nome,
        descricao: editFormData.descricao
      }, config);

      setMessage('Grupo atualizado com sucesso!');
      setEditingGroup(null);
      setEditFormData({ nome: '', descricao: '' });
      fetchGroups(); // Recarregar a lista

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);

    } catch (err) {
      console.error('Erro ao atualizar grupo:', err);
      if (err.response && err.response.data && err.response.data.message) {
        setMessage(err.response.data.message);
      } else {
        setMessage('Erro ao atualizar grupo.');
      }
    }
  };

  const handleSilenceGroup = async (groupId) => {
    setSilenceForm({...silenceForm, grupoId: groupId});
    setShowSilenceModal(true);
  };

  const handleSilenceSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      await api.post(`/api/admin/grupos/${silenceForm.grupoId}/silenciar`, 
        { horas: silenceForm.horas }, 
        config
      );
      
      setMessage(`Grupo silenciado por ${silenceForm.horas} horas!`);
      setShowSilenceModal(false);
      fetchGroups(); // Recarregar a lista
      
      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
      
    } catch (err) {
      console.error('Erro ao silenciar grupo:', err);
      setMessage('Erro ao silenciar grupo.');
    }
  };

  const handleSilenceUser = async (userId) => {
    const horas = prompt('Por quantas horas deseja silenciar este usuário?', '24');
    if (!horas || isNaN(horas) || parseInt(horas) <= 0) {
      return;
    }
    
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      
      await api.post(`/api/admin/users/${userId}/silenciar`, 
        { horas: parseInt(horas) }, 
        config
      );
      
      setMessage(`Usuário silenciado por ${horas} horas!`);
      fetchGroups(); // Recarregar a lista
      
      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
      
    } catch (err) {
      console.error('Erro ao silenciar usuário:', err);
      setMessage('Erro ao silenciar usuário.');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Grupos</h1>
          </div>
          
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
            <p className="mt-4 text-gray-600">Carregando grupos...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <style>{scrollbarStyles}</style>
      <div className="max-w-6xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={onVoltar}
            className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Grupos</h1>
        </div>

        {message && (
          <div className={`mb-6 p-4 rounded-lg ${message.includes('Erro') ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
            {message}
          </div>
        )}

        {/* Lista de grupos */}
        <div className="space-y-6">
          {groups.length > 0 ? (
            groups.map((group) => (
              <div key={group._id} className="bg-white rounded-xl shadow-md border border-gray-200">
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <div className="flex-1">
                      {editingGroup === group._id ? (
                        <div className="space-y-3">
                          <input
                            type="text"
                            value={editFormData.nome}
                            onChange={(e) => setEditFormData({...editFormData, nome: e.target.value})}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
                            placeholder="Nome do grupo"
                          />
                          <textarea
                            value={editFormData.descricao}
                            onChange={(e) => setEditFormData({...editFormData, descricao: e.target.value})}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
                            rows="2"
                            placeholder="Descrição do grupo"
                          />
                          <div className="flex space-x-2">
                            <button
                              onClick={() => saveGroupUpdates(group._id)}
                              className="px-3 py-1 bg-violet-600 hover:bg-violet-700 text-white rounded-lg transition-colors"
                            >
                              Salvar
                            </button>
                            <button
                              onClick={cancelEditingGroup}
                              className="px-3 py-1 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg transition-colors"
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <h2 className="text-xl font-bold text-gray-800">{group.nome}</h2>
                          <p className="text-gray-600 mt-1">{group.descricao}</p>
                          <span className="inline-block mt-2 px-2 py-1 text-xs font-semibold bg-violet-100 text-violet-800 rounded-full">
                            {group.categoria}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="flex space-x-2">
                      {editingGroup !== group._id && (
                        <button
                          onClick={() => startEditingGroup(group)}
                          className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-full transition-colors"
                          title="Editar grupo"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                          </svg>
                        </button>
                      )}
                      <button
                        onClick={() => handleSilenceGroup(group._id)}
                        className="p-2 text-orange-600 hover:text-orange-800 hover:bg-orange-50 rounded-full transition-colors"
                        title="Silenciar grupo"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path>
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Membros do grupo */}
                  <div className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-700 mb-3">Membros ({group.membros?.length || 0})</h3>
                    <div className="flex flex-wrap gap-2">
                      {group.membros && group.membros.length > 0 ? (
                        group.membros.map((member) => (
                          <div key={member._id} className="flex items-center bg-gray-100 rounded-full px-3 py-1">
                            <span className="text-sm font-medium text-gray-700">{member.nome}</span>
                            <button
                              onClick={() => handleRemoveMember(group._id, member._id)}
                              className="ml-2 text-red-500 hover:text-red-700"
                              title="Remover membro"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                              </svg>
                            </button>
                            <button
                              onClick={() => handleSilenceUser(member._id)}
                              className="ml-1 text-orange-500 hover:text-orange-700"
                              title="Silenciar usuário"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path>
                              </svg>
                            </button>
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-500 text-sm">Nenhum membro no grupo</p>
                      )}
                    </div>
                  </div>

                  {/* Mensagens do grupo */}
                  <div>
                    <div className="flex justify-between items-center mb-3">
                      <h3 className="text-lg font-semibold text-gray-700">Mensagens ({group.mensagens?.length || 0})</h3>
                      {group.mensagens && group.mensagens.length > 0 && (
                        <div className="flex space-x-2">
                          <button
                            onClick={() => {
                              const currentSelection = selectedMessages[group._id] || {};
                              const allSelected = group.mensagens.length > 0 &&
                                Object.keys(currentSelection).length === group.mensagens.length;
                              if (allSelected) {
                                deselectAllMessagesInGroup(group._id);
                              } else {
                                selectAllMessagesInGroup(group._id, group.mensagens);
                              }
                            }}
                            className="px-3 py-1 text-sm bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors"
                          >
                            {(() => {
                              const currentSelection = selectedMessages[group._id] || {};
                              const allSelected = group.mensagens.length > 0 &&
                                Object.keys(currentSelection).length === group.mensagens.length;
                              return allSelected ? 'Desmarcar Tudo' : 'Marcar Tudo';
                            })()}
                          </button>
                          <button
                            onClick={() => deleteSelectedMessages(group._id)}
                            className="px-3 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
                          >
                            Apagar Selecionados
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="space-y-3 max-h-96 overflow-y-auto custom-scrollbar">
                      {group.mensagens && group.mensagens.length > 0 ? (
                        group.mensagens.map((message) => {
                          const isSelected = selectedMessages[group._id]?.[message._id];
                          return (
                            <div key={message._id} className={`border rounded-lg p-4 ${isSelected ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}>
                              <div className="flex items-start">
                                <input
                                  type="checkbox"
                                  checked={isSelected || false}
                                  onChange={() => toggleMessageSelection(group._id, message._id)}
                                  className="mt-1 mr-3 h-4 w-4 text-violet-600 rounded focus:ring-violet-500 border-gray-300"
                                />
                                <div className="flex-1">
                                  <div className="flex items-center mb-2">
                                    <span className="font-semibold text-gray-800">{message.autor?.nome || 'Usuário'}</span>
                                    <span className="text-xs text-gray-500 ml-2">
                                      {new Date(message.createdAt).toLocaleString()}
                                    </span>
                                  </div>
                                  <p className="text-gray-700">{message.texto}</p>
                                </div>
                                <button
                                  onClick={() => handleDeleteMessage(group._id, message._id)}
                                  className="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full"
                                  title="Apagar mensagem"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                  </svg>
                                </button>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p className="text-gray-500 text-sm">Nenhuma mensagem no grupo</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="bg-white rounded-xl shadow-md p-8 text-center">
              <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 1 1 -6 0 3 3 0 0 1 6 0zm6 3a2 2 0 1 1 -4 0 2 2 0 0 1 4 0zM7 10a2 2 0 1 1 -4 0 2 2 0 0 1 4 0z"></path>
              </svg>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">Nenhum grupo encontrado</h3>
              <p className="text-gray-500">Não há grupos cadastrados no sistema.</p>
            </div>
          )}
        </div>
      </div>

      {/* Modal de Silenciamento */}
      {showSilenceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 max-w-md w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Silenciar Grupo</h3>
              <button 
                onClick={() => setShowSilenceModal(false)}
                className="text-gray-500 hover:text-gray-800 text-2xl"
              >
                &times;
              </button>
            </div>
            
            <form onSubmit={handleSilenceSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Por quantas horas deseja silenciar o grupo?
                </label>
                <input
                  type="number"
                  value={silenceForm.horas}
                  onChange={(e) => setSilenceForm({...silenceForm, horas: parseInt(e.target.value) || 1})}
                  min="1"
                  max="720"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Máximo: 720 horas (30 dias)</p>
              </div>
              
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setShowSilenceModal(false)}
                  className="px-4 py-2 text-gray-700 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700 transition-colors"
                >
                  Silenciar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// Componente de Gerenciamento de Patrocínio
const SponsorManagement = ({ token, onVoltar }) => {
  const [sponsorData, setSponsorData] = useState({
    sponsorName: 'Plataforma X',
    supportText: 'Apoio Educacional',
    description: '',
    link: '',
    buttonText: 'Saiba mais',
    imageUrl: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    fetchSponsorData();
  }, []);

  const fetchSponsorData = async () => {
    try {
      setLoading(true);
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const response = await api.get('/api/sponsorships/current', config);

      // Extract the fields we need from the response
      setSponsorData({
        sponsorName: response.data.title || 'Plataforma X',
        supportText: response.data.label || 'Apoio Educacional',
        description: response.data.text || "",
        link: response.data.link || "",
        buttonText: response.data.buttonText || 'Saiba mais',
        imageUrl: response.data.logo || ""
      });
    } catch (err) {
      console.error('Erro ao carregar dados do patrocinador:', err);
      setMessage('Erro ao carregar dados do patrocinador. Usando valores padrão.');
      // Set default values
      setSponsorData({
        sponsorName: "Plataforma X",
        supportText: "Apoio Educacional",
        description: "Estude com o apoio da Plataforma X",
        link: "#",
        buttonText: "Saiba mais",
        imageUrl: ""
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSponsorData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setSponsorData(prev => ({
          ...prev,
          imageUrl: reader.result // This will be replaced with actual URL after saving
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      const payload = {
        title: sponsorData.sponsorName,
        label: sponsorData.supportText,
        description: sponsorData.description,
        link: sponsorData.link,
        buttonText: sponsorData.buttonText
      };

      const response = await api.put('/api/sponsorships/current', payload, config);

      setMessage('Patrocinador atualizado com sucesso!');

      // Refresh the data to get the actual saved values
      setTimeout(() => {
        fetchSponsorData();
      }, 1000);
    } catch (err) {
      console.error('Erro ao atualizar patrocinador:', err);
      setMessage('Erro ao atualizar patrocinador: ' + (err.response?.data?.message || err.message));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Patrocínio</h1>
          </div>

          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
            <p className="mt-4 text-gray-600">Carregando dados do patrocinador...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={onVoltar}
            className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Patrocínio</h1>
        </div>

        {message && (
          <div className={`mb-6 p-4 rounded-lg ${message.includes('Erro') ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
            {message}
          </div>
        )}

        <div className="bg-white rounded-xl shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Configurações do Patrocinador</h2>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nome do Patrocinador *
                </label>
                <input
                  type="text"
                  name="sponsorName"
                  value={sponsorData.sponsorName}
                  onChange={handleInputChange}
                  placeholder="Ex: Plataforma X"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Nome da empresa ou plataforma patrocinadora</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Texto de Apoio *
                </label>
                <input
                  type="text"
                  name="supportText"
                  value={sponsorData.supportText}
                  onChange={handleInputChange}
                  placeholder="Ex: Apoio Educacional"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Texto que aparece ao lado do ícone de patrocinado</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Link do Botão *
                </label>
                <input
                  type="url"
                  name="link"
                  value={sponsorData.link}
                  onChange={handleInputChange}
                  placeholder="https://exemplo.com"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">URL para onde o botão levará</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Texto do Botão (CTA) *
                </label>
                <input
                  type="text"
                  name="buttonText"
                  value={sponsorData.buttonText}
                  onChange={handleInputChange}
                  placeholder="Ex: Saiba mais"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Texto do botão de chamada para ação</p>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Texto Descritivo *
                </label>
                <input
                  type="text"
                  name="description"
                  value={sponsorData.description}
                  onChange={handleInputChange}
                  placeholder="Ex: Estude com o apoio da Plataforma X"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">Texto curto que descreve o patrocinador</p>
              </div>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                disabled={saving}
                className="px-6 py-3 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700 transition-colors disabled:bg-violet-400"
              >
                {saving ? 'Salvando...' : 'Salvar Configurações'}
              </button>
            </div>
          </form>
        </div>

        {/* Pré-visualização */}
        <div className="bg-white rounded-xl shadow-md p-6 border-t-2 border-violet-200">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Pré-visualização</h2>
          <div className="relative flex flex-col md:flex-row items-start md:items-center bg-white rounded-xl p-5 md:p-6 shadow-sm ring-1 ring-black/5 leading-none transition-all duration-300">
            <div className="flex-1 flex flex-col gap-3">
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] md:text-xs font-semibold uppercase tracking-wide bg-violet-50 text-violet-700 ring-1 ring-inset ring-violet-200">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-megaphone w-3 h-3" aria-hidden="true">
                    <path d="M12 8.5a2.5 2.5 0 0 0-2.5-2.5"></path>
                    <path d="M8.5 12a2.5 2.5 0 0 0 2.5-2.5"></path>
                    <path d="M12 8.5a2.5 2.5 0 0 1 2.5 2.5"></path>
                    <path d="M14.5 12a2.5 2.5 0 0 1-2.5 2.5"></path>
                    <path d="M12 10v4"></path>
                    <path d="M10 12h4"></path>
                    <path d="M2 12c0-2.8 1.4-5.2 3.5-6.5"></path>
                    <path d="M22 12c0 2.8-1.4 5.2-3.5 6.5"></path>
                  </svg>
                  Patrocinado
                </span>
                <span className="text-xs text-slate-400 font-medium">{sponsorData.supportText || "Apoio Educacional"}</span>
              </div>
              <div className="flex items-center gap-4 mt-1">
                <div className="flex-shrink-0 relative">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 flex items-center justify-center p-0.5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="w-full h-full text-violet-600">
                      <path d="M2 13a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5a1 1 0 0 0 1 1 1 1 0 0 0 1-1V13a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5a1 1 0 0 0 1 1 1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6z"></path>
                      <path d="M14 10v3"></path>
                      <path d="M17 11v1"></path>
                      <path d="M20 10v2"></path>
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-slate-900 group-hover:text-violet-700 transition-colors">{sponsorData.sponsorName || "Plataforma X"}</h3>
                  <p className="text-sm text-slate-500 font-medium leading-relaxed mt-0.5">
                    {sponsorData.description || "Estude com o apoio da Plataforma X"}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 md:mt-0 md:ml-6 w-full md:w-auto flex-shrink-0">
              <a
                href={sponsorData.link || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-flex w-full md:w-auto items-center justify-center gap-2 px-6 py-3 overflow-hidden font-semibold text-white transition-all duration-300 bg-violet-600 rounded-lg group/btn hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-400 focus:ring-offset-2 shadow-md hover:shadow-lg hover:-translate-y-0.5"
              >
                <div className="absolute top-0 -left-[100%] w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-[shimmer_2s_infinite]"></div>
                <span className="relative text-sm">{sponsorData.buttonText || "Saiba mais"}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right w-4 h-4 relative transition-transform duration-300 group-hover/btn:translate-x-1" aria-hidden="true">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </a>
              <div className="hidden md:flex justify-center mt-2">
                <span className="text-[10px] text-slate-400 flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-external-link w-3 h-3" aria-hidden="true">
                    <path d="M15 3h6v6"></path>
                    <path d="M10 14 21 3"></path>
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  </svg> Link seguro
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Componente para adicionar novo usuário
const AdminAddUser = ({ token, onVoltar }) => {
  const [userData, setUserData] = useState({
    nome: '',
    email: '',
    senha: '123456', // Default password
    plano: 'comum'
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      };

      // Use default password if field is empty or only whitespace
      const senhaParaEnviar = userData.senha.trim() === '' ? '123456' : userData.senha;

      // Create the user directly using the admin endpoint
      const response = await api.post('/api/users/admin/create-user', {
        nome: userData.nome,
        email: userData.email,
        senha: senhaParaEnviar,
        plano: userData.plano
      }, config);

      setMessage('Usuário criado com sucesso!');
      setUserData({
        nome: '',
        email: '',
        senha: '123456', // Default password
        plano: 'comum'
      });

      // Clear message after 3 seconds
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error('Erro ao criar usuário:', err);
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Erro ao criar usuário. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-2xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={onVoltar}
            className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Adicionar Novo Usuário</h1>
        </div>

        {message && (
          <div className="mb-6 p-4 rounded-lg bg-green-100 text-green-800">
            {message}
          </div>
        )}

        {error && (
          <div className="mb-6 p-4 rounded-lg bg-red-100 text-red-800">
            {error}
          </div>
        )}

        <div className="bg-white rounded-xl shadow-md p-6">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  name="nome"
                  value={userData.nome}
                  onChange={handleChange}
                  placeholder="Nome completo do usuário"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={userData.email}
                  onChange={handleChange}
                  placeholder="email@exemplo.com"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Senha
                </label>
                <input
                  type="password"
                  name="senha"
                  value={userData.senha}
                  onChange={handleChange}
                  placeholder="Senha padrão: 123456"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
                  minLength="6"
                />
                <p className="text-xs text-gray-500 mt-1">Deixe em branco para usar a senha padrão: 123456</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Plano Inicial
                </label>
                <select
                  name="plano"
                  value={userData.plano}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
                >
                  <option value="comum">Comum</option>
                  <option value="prata">Prata</option>
                  <option value="ouro">Ouro</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-3 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700 transition-colors disabled:opacity-50"
              >
                {loading ? 'Criando...' : 'Criar Usuário'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Componente para gerenciar acesso às seções premium
const SectionAccessManager = ({ token, onVoltar }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [grantForm, setGrantForm] = useState({
    userEmail: '',
    sections: 'both',
    durationDays: 30
  });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchUsersWithAccess();
  }, []);

  const fetchUsersWithAccess = async () => {
    try {
      setLoading(true);
      setError('');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Buscar usuários com acesso às seções premium
      const response = await api.get('/api/section-access/all-users', config);
      setUsers(response.data.data || []);
    } catch (err) {
      console.error('Erro ao carregar usuários com acesso:', err);
      setError('Erro ao carregar usuários com acesso. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleGrantAccess = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      // Prepare sections based on the selection
      let sectionsToSend;
      if (grantForm.sections === 'all') {
        sectionsToSend = 'progress,flashcards'; // Send as comma-separated string (removed enem-tri)
      } else {
        sectionsToSend = grantForm.sections; // Use the selected section
      }

      const updatedGrantForm = {
        ...grantForm,
        sections: sectionsToSend
      };

      await api.post('/api/section-access/grant', updatedGrantForm, config);

      setMessage('Acesso concedido com sucesso!');
      setGrantForm({
        userEmail: '',
        sections: 'all',
        durationDays: 30
      });

      // Recarregar a lista de usuários
      fetchUsersWithAccess();

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error('Erro ao conceder acesso:', err);
      setError(err.response?.data?.message || 'Erro ao conceder acesso. Tente novamente.');
    }
  };

  const handleRemoveAccess = async (userId) => {
    if (!window.confirm('Tem certeza que deseja remover o acesso às seções premium deste usuário?')) {
      return;
    }

    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      await api.delete(`/api/section-access/remove/${userId}`, config);

      setMessage('Acesso removido com sucesso!');
      fetchUsersWithAccess();

      // Limpar mensagem após 3 segundos
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error('Erro ao remover acesso:', err);
      setError(err.response?.data?.message || 'Erro ao remover acesso. Tente novamente.');
    }
  };

  const filteredUsers = users.filter(user =>
    user.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between mb-8">
            <button
              onClick={onVoltar}
              className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Voltar
            </button>
            <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Acesso às Seções</h1>
          </div>

          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
            <p className="mt-4 text-gray-600">Carregando usuários...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={onVoltar}
            className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Gerenciamento de Acesso às Seções</h1>
        </div>

        {message && (
          <div className="mb-6 p-4 rounded-lg bg-green-100 text-green-800">
            {message}
          </div>
        )}

        {error && (
          <div className="mb-6 p-4 rounded-lg bg-red-100 text-red-800">
            {error}
          </div>
        )}

        {/* Formulário para conceder acesso */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Conceder Acesso a Seções Premium</h2>

          <form onSubmit={handleGrantAccess}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email do Usuário *
                </label>
                <input
                  type="email"
                  name="userEmail"
                  value={grantForm.userEmail}
                  onChange={(e) => setGrantForm({...grantForm, userEmail: e.target.value})}
                  placeholder="email@usuario.com"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Seções
                </label>
                <select
                  name="sections"
                  value={grantForm.sections}
                  onChange={(e) => setGrantForm({...grantForm, sections: e.target.value})}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                >
                  <option value="all">Todas as Seções (Progresso e Flashcards)</option>
                  <option value="progress">Acesso a Progresso</option>
                  <option value="flashcards">Acesso a Flashcards</option>
                  <option value="progress,flashcards">Acesso a Progresso e Flashcards</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Duração
                </label>
                <select
                  name="durationDays"
                  value={grantForm.durationDays}
                  onChange={(e) => setGrantForm({...grantForm, durationDays: parseInt(e.target.value)})}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-violet-500 focus:border-violet-500"
                >
                  <option value={30}>30 dias</option>
                  <option value={90}>90 dias</option>
                  <option value={180}>180 dias</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="px-6 py-3 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700 transition-colors"
              >
                Conceder Acesso
              </button>
            </div>
          </form>
        </div>

        {/* Barra de busca */}
        <div className="mb-6">
          <div className="relative">
            <input
              type="text"
              placeholder="Buscar usuários por nome ou email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500"
            />
            <svg className="w-5 h-5 text-gray-400 absolute left-3 top-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>

        {/* Lista de usuários com acesso */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-800">Usuários com Acesso às Seções Premium</h3>
            <p className="text-sm text-gray-600 mt-1">{filteredUsers.length} usuário(s) encontrados</p>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Usuário
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Seções com Acesso
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data de Expiração
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <tr key={user._id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10">
                            <div className="h-10 w-10 rounded-full bg-violet-100 flex items-center justify-center">
                              <span className="text-violet-800 font-semibold">
                                {user.nome ? user.nome.charAt(0).toUpperCase() : '?'}
                              </span>
                            </div>
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">{user.nome || 'Nome não disponível'}</div>
                            <div className="text-sm text-gray-500">{user.email || 'Email não disponível'}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {user.premiumAccessSections && user.premiumAccessSections.length > 0 ? (
                            user.premiumAccessSections.map(section =>
                              section === 'progress' ? 'Progresso' :
                              section === 'flashcards' ? 'Flashcards' :
                              section === 'enem-tri' ? 'Simulador ENEM TRI' : section
                            ).join(', ')
                          ) : 'Nenhuma'}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {user.premiumAccessExpiry ? new Date(user.premiumAccessExpiry).toLocaleDateString('pt-BR') : 'N/A'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <button
                          onClick={() => handleRemoveAccess(user._id)}
                          className="text-red-600 hover:text-red-900"
                          title="Remover acesso"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                      Nenhum usuário com acesso às seções premium encontrado
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

// Página Administrativa Principal
const AdminPage = ({ token, onVoltar, user, onUpdateUser }) => {
  const [activeTab, setActiveTab] = useState('users');

  const renderActiveTab = (user, onUpdateUser) => {
    switch (activeTab) {
      case 'dashboard':
        return <AdminDashboard onVoltar={onVoltar} token={token} />;
      case 'users':
        return <AdminUsers onVoltar={onVoltar} token={token} user={user} onUpdateUser={onUpdateUser} />;
      case 'store':
        return <ProductManagement onVoltar={onVoltar} token={token} />;
      case 'groups':
        return <AdminGroups onVoltar={onVoltar} token={token} />;
      case 'requests':
        return <RegistrationRequestsPage onVoltar={onVoltar} token={token} />;
      case 'cronograma-access':
        return <CronogramaAccessManager />;
      case 'sponsor':
        return <SponsorManagement onVoltar={onVoltar} token={token} />;
      case 'add-user':
        return <AdminAddUser onVoltar={onVoltar} token={token} />;
      case 'section-access':
        return <SectionAccessManager onVoltar={onVoltar} token={token} />;
      case 'tri-access':
        return <TriAccessManager onVoltar={onVoltar} token={token} />;
      default:
        // Se não for uma opção conhecida, redireciona para a página de usuários
        return <AdminUsers onVoltar={onVoltar} token={token} user={user} onUpdateUser={onUpdateUser} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={onVoltar}
            className="flex items-center text-violet-600 hover:text-violet-800 font-semibold transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Voltar
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Área Administrativa</h1>
        </div>

        {/* Menu Administrativo */}
        <AdminMenu onNavigate={setActiveTab} activePage={activeTab} />

        {/* Conteúdo da aba ativa */}
        <div className="bg-white rounded-xl shadow-md p-6">
          {renderActiveTab(user, onUpdateUser)}
        </div>
      </div>
    </div>
  );
};




export default AdminPage;